import CrudManager from "@/components/admin/CrudManager";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { ADMIN } from "@/constants/testIds";

const DEFAULT = { question: "", answer: "", category: "General", order: 0, published: true };

export default function AdminFAQ() {
  return (
    <CrudManager
      title="FAQs"
      subtitle="Manage the frequently asked questions displayed on the website."
      endpoint="/admin/faqs"
      defaultItem={DEFAULT}
      testId={ADMIN.faqsList}
      searchKeys={["question", "answer"]}
      listRender={(f) => (
        <div className="min-w-0 flex-1">
          <p className="text-[0.65rem] tracking-widest uppercase text-gold">{f.category || "General"}</p>
          <p className="mt-1 font-serif text-lg text-foreground line-clamp-1">{f.question}</p>
          <p className="mt-1 text-xs text-foreground/60 line-clamp-2">{f.answer}</p>
        </div>
      )}
      formRenderer={(v, patch) => (
        <>
          <div>
            <Label>Question</Label>
            <Input className="mt-2 rounded-sm" value={v.question} onChange={(e) => patch({ question: e.target.value })} />
          </div>
          <div>
            <Label>Answer</Label>
            <Textarea className="mt-2 rounded-sm min-h-[130px]" value={v.answer} onChange={(e) => patch({ answer: e.target.value })} />
          </div>
          <div className="grid md:grid-cols-3 gap-4 items-end">
            <div>
              <Label>Category</Label>
              <Input className="mt-2 rounded-sm" value={v.category} onChange={(e) => patch({ category: e.target.value })} />
            </div>
            <div>
              <Label>Display Order</Label>
              <Input type="number" className="mt-2 rounded-sm" value={v.order} onChange={(e) => patch({ order: parseInt(e.target.value) || 0 })} />
            </div>
            <label className="flex items-center gap-3 p-3 rounded-sm border border-border/60 bg-secondary/40 cursor-pointer">
              <Switch checked={v.published} onCheckedChange={(c) => patch({ published: c })} />
              <span className="text-sm">Published</span>
            </label>
          </div>
        </>
      )}
    />
  );
}
